export enum Socket {
	CASE_TAKEN = 'caseTaken',
	CASE_CREATED = 'caseCreated',
	USER_CONSENT_ACCEPTED = 'userConsentAccepted',
	USER_TYPING = 'userTyping',
	INSURANCE_REPORT_CREATED = 'insuranceReportCreated',
	JOB_COMPLETED = 'job:completed',
	MESSAGE = 'message',
	LABORATORY_REQUISITION = 'laboratoryRequisition',
	USER_ACL_REFRESH = 'userAclRefresh',
}
